import React from 'react';
import './MembersSection.css';
import { LoadingState, ErrorState } from '../../../components';

function MembersSection({ members, loading, error }) {

  if (loading) {
    return (
      <section className="members-section">
        <div className="members-container">
          <LoadingState message="Caricamento membri..." />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="members-section">
        <div className="members-container">
          <ErrorState message={`Errore nel caricamento dei membri: ${error}`} />
        </div>
      </section>
    );
  }

  if (!members || members.length === 0) {
    return (
      <section className="members-section">
        <div className="members-container">
          <div className="no-data-message">
            <p>Nessun membro da visualizzare</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="members-section">
      <div className="members-overlay"></div>
      <div className="members-container">
        <div className="section-title">
          <h3>I nostri membri</h3>
          <div className="title-icon">
            <i className="fa-solid fa-heart"></i>
          </div>
        </div>
        <div className="members-grid">
          {members.map((member, index) => (
            <div key={index} className="member-card">
              <div className="member-image">
                {member.photo_link ? (
                  <img src={member.photo_link} alt={`${member.name} ${member.surname}`} />
                ) : (
                  <div className="member-placeholder">
                    <i className="fa-solid fa-user"></i>
                  </div>
                )}
              </div>
              <div className="member-info">
                <h4>{member.name} {member.surname}</h4>
                <p className="member-role">{member.role}</p>
                {member.description && (
                  <p className="member-description">{member.description}</p>
                )}
                <div className="member-social">
                  {member.facebook_link && (
                    <a href={member.facebook_link} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                      <i className="fa-brands fa-facebook"></i>
                    </a>
                  )}
                  {member.instagram_link && (
                    <a href={member.instagram_link} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  )}
                  {member.linkedin_link && (
                    <a href={member.linkedin_link} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                      <i className="fa-brands fa-linkedin"></i>
                    </a>
                  )}
                  {member.twitter_link && (
                    <a href={member.twitter_link} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                      <i className="fa-brands fa-x-twitter"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MembersSection;
